export default "__VITE_PUBLIC_ASSET__d7ce71e4__"